import { LoadingSpinner } from '@/components/shared/loading-spinner'

type ReaderLoadingProps = {
  message?: string
}

/** リーダー準備中のスピナー */
export const ReaderLoading = ({ message }: ReaderLoadingProps) => (
  <div className="fixed inset-0 flex items-center justify-center pointer-events-none">
    <LoadingSpinner loading message={message} fullscreen={false} />
  </div>
)
